export default function WarningIcon() {
    return (
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle cx="12" cy="12.2454" r="12" fill="#E3A21E" />
            <g clipPath="url(#clip0_1331_9596)">
                <path
                    opacity="0.4"
                    d="M10.4688 16.7454H14.0312C14.0928 16.7454 14.1538 16.7575 14.2106 16.781C14.2675 16.8046 14.3192 16.8391 14.3627 16.8827C14.4062 16.9262 14.4408 16.9779 14.4643 17.0347C14.4879 17.0916 14.5 17.1526 14.5 17.2141V17.7766C14.5 17.8382 14.4879 17.8991 14.4643 17.956C14.4408 18.0129 14.4062 18.0645 14.3627 18.1081C14.3192 18.1516 14.2675 18.1861 14.2106 18.2097C14.1538 18.2332 14.0928 18.2454 14.0312 18.2454H10.4688C10.3444 18.2454 10.2252 18.196 10.1373 18.1081C10.0494 18.0202 10 17.9009 10 17.7766V17.2141C10 17.0898 10.0494 16.9706 10.1373 16.8827C10.2252 16.7947 10.3444 16.7454 10.4688 16.7454Z"
                    fill="#F8F8F6"
                />
                <path
                    d="M12.25 9.24536C12.5467 9.24536 12.8367 9.15739 13.0834 8.99257C13.33 8.82774 13.5223 8.59348 13.6358 8.31939C13.7494 8.0453 13.7791 7.7437 13.7212 7.45273C13.6633 7.16176 13.5204 6.89448 13.3107 6.6847C13.1009 6.47492 12.8336 6.33206 12.5426 6.27418C12.2517 6.21631 11.9501 6.24601 11.676 6.35954C11.4019 6.47307 11.1676 6.66533 11.0028 6.91201C10.838 7.15868 10.75 7.44869 10.75 7.74536C10.75 8.14319 10.908 8.52472 11.1893 8.80602C11.4706 9.08733 11.8522 9.24536 12.25 9.24536ZM12.9062 10.7454H10.4688C10.3444 10.7454 10.2252 10.7947 10.1373 10.8827C10.0494 10.9706 10 11.0898 10 11.2141V11.7766C10 11.9009 10.0494 12.0202 10.1373 12.1081C10.2252 12.196 10.3444 12.2454 10.4688 12.2454H11.125V16.7454H13.375V11.2141C13.375 11.0898 13.3256 10.9706 13.2377 10.8827C13.1498 10.7947 13.0306 10.7454 12.9062 10.7454Z"
                    fill="#F8F8F6"
                />
            </g>
            <defs>
                <clipPath id="clip0_1331_9596">
                    <rect
                        width="4.5"
                        height="12"
                        fill="white"
                        transform="translate(10 6.24536)"
                    />
                </clipPath>
            </defs>
        </svg>
    );
}
